<template>
  <footer>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
            <p class="guardians">Guardians of the Ocean</p>
        </div>
        <div class="col-md-12">
            <p>
                Innovacción Virtual
            </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
footer {
  background: #0d1321;
  color: #f1f1f1;
  padding: 2rem;
}
.guardians {
  font-size: 2rem;
  font-weight: 800;
  color: #f1f1f1;
  margin-bottom: 1rem;
  margin-top: 1rem;
}
</style>

export default {
  name: 'Footer',
  components: {
  },
};
